<template>
  <el-popover placement="bottom" width="600" trigger="click">
    <vxe-grid
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      size="mini"
      resizable
      border
    >
      <template v-slot:pager>
        <pagination
          size="small"
          align="right"
          :layouts="[
            'Total',
            'Sizes',
            'PrevPage',
            'NextPage',
          ]"
          :current-page="page.curPage"
          :page-size="page.pageSize"
          :page-total="page.pageTotal"
          @change="handlePaginationChange"
        />
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-badge
            is-dot
            class="itembadge"
            :value="row.hasDownName"
            :hidden="
              row.hasDown === 'Y' || row.downloadStatus !== 'Y'
            "
          >
            <b-icon
              icon="download"
              font-scale="1.5"
              aria-hidden="true"
              style="color: #98a6ad"
              @click="downloadFile(row)"
              v-show="row.downloadStatus === 'Y'"
            ></b-icon>
          </el-badge>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
    <el-button
      class="btn-text can-hover"
      type="text"
      slot="reference"
      @click="getList"
    >
      <el-badge
        :value="formData.noDownloadCount"
        :hidden="formData.noDownloadCount === 0"
      >
        <i class="fa fa-download"></i>
      </el-badge>
    </el-button>
  </el-popover>
</template>
<script>
import tableColumns from './table-columns'
export default {
  data() {
    return {
      formData: {
        noDownloadCount: 0
      },
      visible: false,
      tableData: [],
      loading: false,
      page: {
        curPage: 1,
        pageSize: 5,
        pageTotal: 0
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {},
  created() {
    this.queryNoDownloadNumber()
  },
  destroyed() {
    clearTimeout(this.taskId)
  },
  methods: {
    queryNoDownloadNumber() {
      this.$api.queryNoDownloadApi().then((res) => {
        this.formData = res.body
        this.taskId = setTimeout(() => this.queryNoDownloadNumber(), 10000)
      })
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.$nextTick(() => {
        this.getList()
      })
    },
    getList() {
      this.loading = true
      this.$api
        .querySysDownloadListApi({ ...this.page })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    downloadFile(row) {
      console.log(row.downloadUrl)
      if (row.downloadUrl) {
        // 兼容之前上传的有记录完整路径的上传文档
        window.open(row.downloadUrl)
      }
    }
  }
}
</script>
<style lang="scss">
.itembadge {
  margin-top: 10px;
}
</style>
